import React from 'react';
import PropTypes from 'prop-types';

const CustomInput1 = ({ label, value, placeholder, onChange, name }) => {
  return (
    <div className="flex flex-col items-start gap-2 w-[264px] h-[90px]">
      <label className="w-full text-[20px] leading-[25px] font-normal text-[#4A4A4A]">
        {label}
      </label>
      <div className="flex items-center px-8 py-4 gap-4 w-full h-[57px] bg-[#F7F3EC] rounded-lg">
        <input
          type="text"
          name={name}
          className="w-full h-[25px] text-[20px] leading-[25px] font-bold text-[#4A4A4A] bg-transparent outline-none"
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

CustomInput1.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

CustomInput1.defaultProps = {
  value: '',
  placeholder: 'Enter value',
};

export default CustomInput1;